import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  fill: "none",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#000\" stroke-width=\"4.5\" clip-path=\"url(#empty_cart_svg__a)\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M48.723 52.902H21.068a4.18 4.18 0 0 1-4.123-3.485L9.595 6.211a4.18 4.18 0 0 0-4.123-3.476H2.729\"></path><path d=\"M43.496 61.265a1.045 1.045 0 1 0 0-2.091m0 2.091a1.045 1.045 0 1 1 0-2.091M22.59 61.265a1.045 1.045 0 1 0 0-2.091m0 2.091a1.045 1.045 0 0 1 0-2.091\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15.404 40.358h33.648a8.36 8.36 0 0 0 8.112-6.333l4.042-16.167a2.09 2.09 0 0 0-2.03-2.598h-8.039m-30.362 0h-8.04\"></path></g><path stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"4.5\" d=\"M42.3 8 28.8 21.5m0-13.5 13.5 13.5\"></path><defs><clipPath id=\"empty_cart_svg__a\"><path fill=\"#fff\" d=\"M0 0h64v64H0z\"></path></clipPath></defs>", 3)
  ])))
}
export default { render: render }